export const truncateToWholeWords = (s: string, maxLength: number) => {
  if (s.length <= maxLength) return s;

  const baseResult = s.substring(0, maxLength + 1);
  const lastWhiteCharacter = baseResult.search(/ [^ ]*$/);
  return baseResult.substring(0, lastWhiteCharacter) + " ...";
};
